const data = {
  func: {
    title: "产品优势·特色服务",
    list: [
      { title: "100+", desc: "标准服务接口" },
      { title: "10类", desc: "商品、订单、物流、发票等10大采购功能模块" },
      { title: "毫秒级", desc: "接口响应时效" },
      { title: "8*5客服服务", desc: "企业专属客服" },
      { title: "电子发票", desc: "无纸化、低能耗、易保存、 易查询" },
      { title: "智能寻源", desc: "AI技术寻找货源，降低采购成本" },
      {
        title: "一单多地址",
        desc: "一笔大采购单，一次审批、 一次报销、一次开票申请",
      },
      { title: "银企直连", desc: "对公转账自动认款" },
    ],
  },
  style: {
    isShowSubTitle: "show",
    wrapPadding: { unit: 2, quantity: "px" },
    backColor: "#dddddd",
    titlePosition: ["center"],
  },
  data: {
    event: { trigger: "() => {}", eventData: "{}" },
    getData: [{ name: "" }],
  },
};

export default data;
